<template>
  <div class="sub3">

    <lnb></lnb>

    <div class="inner">

      <!--SECTION-->
      <section class="sec1">

        <img src="img/pic_angle1.png" alt="" class="angle">
        <div class="scroll_box" ref="scrollBox">
          <div class="inner">

            <img src="img/txt_talia.png" alt="" class="pic">
            <a><img src="img/btn_delivery.png" alt="" class="btn1"></a>

            <a><img src="img/filter_select.png" alt="" class="scroll"></a>
            <a><img src="img/btn_sizeguide.png" alt="" class="btn2"></a>

            <a class="btn3"></a>
            <a class="btn4"></a>
          </div>
        </div>

      </section>


      <!--SECTION-->
      <section class="sec2">
        <img src="img/pic_angle2.png" alt="" class="angle">
      </section>


      <!--SECTION-->
      <section class="sec3">
        <img src="img/pic_angle3.png" alt="" class="angle">
      </section>


      <!--SECTION-->
      <section class="sec4">
        <img src="img/pic_angle4.png" alt="" class="angle">
      </section>


      <!--SECTION-->
      <section class="sec5">
        <img src="img/pic_angle5.png" alt="" class="angle">
      </section>


      <!--SECTION-->
      <section class="sec6">
        <img src="img/txt_youmayalsolike.png" alt="" class="title">
        <a @click="changeContentsName('Sub2')"><img src="img/btn_viewall.png" alt="" class="btn"></a>
        <a @click="changeContentsName('Sub2')"><img src="img/pic_youmayalsolike.png" alt="" class="pic"></a>
      </section>

    </div>
  </div>
</template>

<script>
  import { mapMutations } from 'vuex'
  import Lnb from './Lnb.vue'

  export default {
    name: 'Sub3age',
    components: {
      Lnb
    },
    data () {
      return {

      }
    },
    methods: {
      ...mapMutations([
        'changeContentsName'
      ]),
      fixedScrollBox () {
        window.addEventListener('scroll', () => {
          console.log(window.pageYOffset)
          if (window.pageYOffset  > 135 && window.pageYOffset < 4000) {
            this.$refs.scrollBox.classList.add('fixed')
            this.$refs.scrollBox.classList.remove('fixed-absolute')
          } else if (window.pageYOffset >= 3900) {
            this.$refs.scrollBox.classList.remove('fixed')
            this.$refs.scrollBox.classList.add('fixed-absolute')
          } else {
            this.$refs.scrollBox.classList.remove('fixed')
            this.$refs.scrollBox.classList.remove('fixed-absolute')
          }
        })
      }
    },
    mounted () {
      this.fixedScrollBox()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Sub3Page.vue